<template>
  <div class="sites-overview">

    <!-- Label - sites -->
    <h3 class="sites-overview-label">
     {{ $t('CreateWebsite.title') }}
    </h3>

    <div class="spacer-title-bottom d-none d-md-block" />
    <div class="spacer-title-bottom-smaller d-block d-md-none" />

    <!-- Placeholders for available sites -->
    <div
      class="row"
      data-v-step="websites.edit">
      <!-- List user's sites -->
      <div
        v-for="site in getUserSites"
        :key="site.id"
        class="col-md-6 col-sm-12 text-center site-piholders">

        <credentials-box
          :credentials="site"
          :iconParams="site.iconParams">

          <div slot="actions">
            <a :href="site.meta.editUrl" target="blank">
              <input-button
                class="site-action-button"
                smaller
                hollow
                btnStyle="ok-style"
                pointable
                variant="standardInput"
                :inputPlaceholder="$t('Button.edit')" />

            </a>

            <a :href="site.meta.viewUrl" target="blank">
              <input-button
                class="site-action-button"
                smaller
                hollow
                btnStyle="ok-style"
                pointable
                variant="standardInput"
                :inputPlaceholder="$t('Button.view')" />

            </a>
          </div>
        </credentials-box>
      </div>
      
      <!-- List special placeholders - new site, etc. -->
      <div
        v-for="site in getSpecialSiteBoxes"
        :key="site.id"
        class="col-md-6 col-sm-12 text-center site-piholders">

        <credentials-box
          :credentials="site"
          :iconParams="site.iconParams">

          <div slot="actions">
            <input-button
              class="site-action-button"
              smaller
              hollow
              btnStyle="ok-style"
              pointable
              variant="standardInput"
              :inputPlaceholder="$t('Button.createSite')"
              @click="connectSite(site)" />

          </div>
        </credentials-box>
      </div>
    </div>

    <div class="spacer-section d-none d-md-block" />
    <div class="spacer-section-smaller d-block d-md-none" />

    <!-- Label - shop -->
    <h3 class="sites-overview-label">
      <span class="mr-1 mr-md-2">
        {{ $t('CreateShop.title') }}
      </span>
    </h3>

    <!-- Placeholders for available shops -->
    <div>
      <div
        class="row"
        data-v-step="websites.onlineStore">

        <div
          v-for="shop in getShopList"
          :key="shop.id"
          class="col-md-6 text-center site-piholders">

          <credentials-box :credentials="shop">
            <div slot="actions">
              <a
                v-if="!shop.connected"
                href="https://acenta.si/izdelava-spletnih-trgovin"
                target="blank">

                <input-button
                  class="site-action-button"
                  smaller
                  hollow
                  btnStyle="ok-style"
                  pointable
                  variant="standardInput"
                  :inputPlaceholder="$t('Shop.info.label')" />

              </a>

              <a
                v-else
                :href="shop.viewLink"
                target="blank">

                <input-button
                  class="site-action-button"
                  smaller
                  hollow
                  btnStyle="ok-style"
                  pointable
                  variant="standardInput"
                  :inputPlaceholder="$t('Button.view')" />

              </a>
            </div>
          </credentials-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paramExtractor from '@/assets/modules/channels/paramExtractor'
import InputButton from '@/components/standard/input/InputButton'
import CredentialsBox from '@/components/standard/display/CredentialsBox'

import channels from '@/mixins/pagination/providers/channels'
import routingHelper from '@/assets/modules/routing/routingHelper'

export default {
  methods: {
    /**
     * Handeles special container's events
     * @param {Object} e
     */
    connectSite (e) {
      switch (e.type) {
        case 'createNewSite':
          routingHelper.redirectToInternal(this, 'siteCreate')
      }
    }
  },

  computed: {
    /**
     * Gives shop list items to be displayed
     * @returns {Array}
     */
    getShopList () {
      let rtr = []
      let connected = {}
      for (let c of this.getCredentials) {
        connected[c.type] = c.meta.shopUrl || true
      }

      let acceptedCredentials = ['wooCommerceShop', 'shopamineShop']
      for (let ac of acceptedCredentials) {
        let extracted = paramExtractor.extract(ac)
        rtr.push({
          connected: !!connected[ac],
          label: extracted.label,
          type: ac,
          viewLink: connected[ac],
          id: ac
        })
      }

      return rtr
    },

    /**
     * Gives special boxes in upper website list section
     * @returns {Array}
     */
    getSpecialSiteBoxes () {
      return [{
        type: 'createNewSite',
        id: 'special-create-site-id',
        label: this.$t('CreateWebsite.subtitle'),
        iconParams: {
          icon: 'sqwizr',
          pack: 'clear'
        }
      }]
    },

    /**
     * Gives user's sites
     * @returns {Array}
     */
    getUserSites () {
      let rtr = []
      let acceptedTypes = {
        'sqwizPage': true,
        'wordpressWebsite': true,
      }

      for (let c of this.getCredentials) {
        if (acceptedTypes[c.type]) {
          c = JSON.parse(JSON.stringify(c))

          if (c.type === 'wordpressWebsite') {
            c.meta.editUrl = `${c.label}/wp-admin`
            c.meta.viewUrl = c.label
          }

          // Custom icon
          c.isIcon = true
          c.iconParams = {
            icon: 'webSite',
            pack: 'leftMenu',
          }
          rtr.push(c)
        }
      }
      return rtr
    }
  },

  components: {
    'credentials-box': CredentialsBox,
    'input-button': InputButton
  },

  mixins: [
    channels
  ]
}
</script>

<style scoped>
.spacer-title-bottom {
  margin-bottom: 20px;
}
.spacer-title-bottom-smaller {
  margin-bottom: 4px;
}
.spacer-section {
  margin-bottom: 64px;
}
.spacer-section-smaller {
  margin-bottom: 24px;
}

.sites-overview-label {
  font-size: 16px;
  font-weight: bold;
}
.sites-overview-label a {
  font-weight: lighter;
}

.sites-overview {
  overflow: hidden;
}

.site-piholders {
  padding: 9px!important;
  transition: all .3s;
}
.remove-link-styles {
  color: #D2D3D4!important;
}

.site-action-button {
  margin: 0 7px;
}

@media (max-width: 768px) {
  .site-piholders {
    padding: 2.5px!important;
    padding-left: 15px!important;
    padding-right: 15px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/service/siteManager/SitesOverview.vue?9f650cfe